import {Box, Tooltip} from '@mui/material';
import AddButton from '../../../UserScreen/InventoryPage/InventorySettings/components/AddButton/AddButton';
import terminal_icon from "../../../asset/image/terminal_icon.svg";
import green_router from "../../../asset/image/green_router.svg";

interface TerminalAndRouter {
    terminalData: any;
    setTerminalData: any;
    handleterminalClick: any;
    isTerminalSelected: boolean;
    selectedTrml: any;
    handleRouterClick: any;
    isRouterSelected: boolean;
    selectedRutr: any;
    setOpenAddToServiceLinePopup: any;
}
const TerminalAndRouters = (props: TerminalAndRouter) => {
    const {terminalData, setTerminalData, handleterminalClick, isTerminalSelected, selectedTrml, handleRouterClick, isRouterSelected, selectedRutr, setOpenAddToServiceLinePopup} = props;
 return(
    
        <Box className="temrinalAndRoutersContainer">
            {terminalData.map((terminal) => (
                <Box>
                    <Tooltip title='Terminal'>
                        <Box
                        //   key={profile.id}
                            className={`terminalRouters ${isTerminalSelected && selectedTrml === terminal.device_id ? "selectedTerminal" : ""}`}
                            onClick={() =>
                                handleterminalClick(terminal.device_id)
                            }
                        >
                            <div style={{display:"flex", alignItems:"center"}} title={terminal.kitNumber}>
                                    <img
                                        src={terminal_icon}
                                        width="18"
                                        height="18"
                                    />
                            </div>
                        </Box>
                    </Tooltip>
                    {/* {terminal?.routers?.length > 0 && (
                        <Box sx={{ width: "1px", height: "20px", backgroundColor: "#eee", margin: "0px 16px" }} />
                    )} */}
                    {<Box mb={1.5}>
                        {terminal?.routers?.map((router) => (
                            <div>
                                <Box className="verticalConnection"/>
                                <Tooltip title={router.router_device_id}>
                                    <Box
                                        className={`routerList ${isRouterSelected && selectedRutr.router_id == router.router_id ? "selectedRouter" : ""}`}
                                        key={router.router_id}
                                        onClick={() =>
                                            handleRouterClick(router, terminal.device_id)
                                        }
                                    >
                                            <img 
                                                src={green_router}
                                                width="16px"
                                                height="16px"
                                            />
                                    </Box>
                                </Tooltip>
                            </div>
                    ))}
                    </Box>
                }
                </Box>
            ))}
            <Box className="addTerminal">
                {<AddButton onAddClick={()=>{setOpenAddToServiceLinePopup(true)}} addLabel="+" maxWidth="32px" minWidth="25px" tooltip='Add Terminal' />}
            </Box>
        </Box>
 )
}

export default TerminalAndRouters;